import { eventEmitter } from "../../../services";
import { OrderedSet } from "immutable";

export const AUTOCOMPLETE_SHOW = "autocomplete/show";
export const AUTOCOMPLETE_HIDE = "autocomplete/hide";
export const AUTOCOMPLETE_NEXT = "autocomplete/next";
export const AUTOCOMPLETE_PREV = "autocomplete/prev";
export const AUTOCOMPLETE_SELECT = "autocomplete/select";
export const AUTOCOMPLETE_REPLACE_VALUE = "autocomplete/replaceValue";

export class AutoCompleteService {
    private word: string = "";
    private list = OrderedSet<string>();
    private hidden: boolean = true;

    set(words: OrderedSet<string>) {
        this.list = OrderedSet<string>(words.sort());
    }

    clear() {
        this.list = this.list.clear();
        this.hidden = true;
        eventEmitter.emit(AUTOCOMPLETE_HIDE);
    }

    ask(word: string) {
        if (!this.list) {
            return;
        }

        if (word === this.word && this.isVisible()) {
            return;
        }

        this.word = word;
        const result = this.list.filter(
            (value?: string) =>
                typeof value !== "undefined" &&
                value !== word &&
                value.startsWith(word)
        );

        if (result.count() > 0) {
            this.show(OrderedSet<string>(result.slice(0, 5)));
        } else {
            this.hide();
        }
    }

    replaceValue(word: string) {
        this.hide();
        eventEmitter.emit(AUTOCOMPLETE_REPLACE_VALUE, this.word, word);
    }

    show(result: OrderedSet<string>) {
        this.hidden = false;
        eventEmitter.emit(AUTOCOMPLETE_SHOW, result);
    }

    hide() {
        this.hidden = true;
        eventEmitter.emit(AUTOCOMPLETE_HIDE);
    }

    prev() {
        eventEmitter.emit(AUTOCOMPLETE_PREV);
    }

    next() {
        eventEmitter.emit(AUTOCOMPLETE_NEXT);
    }

    isEmpty() {
        return this.list.count() === 0;
    }

    isHidden() {
        return this.hidden;
    }

    isVisible() {
        return !this.hidden;
    }
}
